import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8)
};

const PRIMARY = {
  lighter: '#f5e6c8',
  light: '#edd9a7',
  main: '#e7c873',
  dark: '#d9b85c',
  darker: '#c9a545',
  contrastText: '#3d3e3f',
  barYellow: '#e7c873',
  sidebar: '#1a1a1a',
  lightmain: '#f5e6c8',
  hover: '#edd9a7',
  titledark: '#1a1a1a',
  title: '#3d3e3f',
  disabled: '#C4CDD5',
  white: '#ffffff',
  inputborder: '#ebebeb',
  inputbordererror: '#eb664e',
  deleteButtonTitle: '#eb664e',
  tableHeadTitle: '#637381',
  pageButtonTitle: '#1a1a1a',
  pageButtonBorder: '#ebebeb',
  dropdownArrow: '#3d3e3f',
  highlightBLue: '#e0f2fe'
};

const SECONDARY = {
  lighter: '#4d4d4d',
  light: '#333333',
  main: '#1a1a1a',
  dark: '#0d0d0d',
  darker: '#000000',
  contrastText: '#fff'
};

const INFO = {
  lighter: '#e8f4f2',
  light: '#c8e4df',
  main: '#1f4b43',
  dark: '#183d36',
  darker: '#112e29',
  contrastText: '#fff'
};

const SUCCESS = {
  lighter: '#e8f4f2',
  light: '#1f4b43',
  main: '#1f4b43',
  dark: '#183d36',
  darker: '#112e29',
  contrastText: '#fff'
};

const WARNING = {
  lighter: '#fdede9',
  light: '#f5c8bc',
  main: '#e7c873',
  dark: '#d9b85c',
  darker: '#c9a545',
  contrastText: '#3d3e3f'
};

const ERROR = {
  lighter: '#fdede9',
  light: '#f5c8bc',
  main: '#eb664e',
  dark: '#d85a44',
  darker: '#c44e3a',
  contrastText: '#fff'
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};

const CHART_COLORS = {
  // violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  // blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  // green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  // yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  // red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4']
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,

  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: GREY[500_24],
  text: { 
    primary: '#3d3e3f', 
    secondary: GREY[600], 
    disabled: GREY[500], 
    inactive: GREY[0] 
  },
  background: { 
    paper: '#fff', 
    default: '#000000', 
    neutral: GREY[200] 
  },
  drawerBackground: SECONDARY.main,
  action: {
    active: GREY[600],
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
};

export default palette;